import { serviceProviderInitialState, ServiceProviderJson } from "../../../../domain/service_provider/ServiceProvider";
import { createSlice } from "@reduxjs/toolkit";
import {
    ActionType,
    getServiceProviderInformationAction,
    getServiceProviderListAction,
    registerServiceProviderInformationAction,
    updateServiceProviderInformationAction
} from "./actions";

export type AdminServiceProviderState = Readonly<{
    serviceProviders: ServiceProviderJson[] | null,
    serviceProviderInformation: ServiceProviderJson,
    processing: number
}>;

const adminServiceProviderInitialState: AdminServiceProviderState = {
    serviceProviders: null,
    serviceProviderInformation: serviceProviderInitialState,
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: adminServiceProviderInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getServiceProviderListAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getServiceProviderListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.processing -= 1;
                    state.serviceProviders = payload.serviceProviders;
                }
            )
            .addCase(
                getServiceProviderListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getServiceProviderInformationAction.pending,
                (state) => {
                    state.processing += 1;
                    state.serviceProviderInformation = serviceProviderInitialState;
                }
            )
            .addCase(
                getServiceProviderInformationAction.fulfilled,
                (state, action) => {
                    state.processing -= 1;
                    state.serviceProviderInformation = action.payload.serviceProviderInformation;
                }
            )
            .addCase(
                getServiceProviderInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                registerServiceProviderInformationAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                registerServiceProviderInformationAction.fulfilled,
                (state) => {
                    state.processing -= 1;
                    state.serviceProviders = null;
                }
            )
            .addCase(
                registerServiceProviderInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                updateServiceProviderInformationAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                updateServiceProviderInformationAction.fulfilled,
                (state) => {
                    state.processing -= 1;
                    state.serviceProviders = null;
                }
            )
            .addCase(
                updateServiceProviderInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const adminServiceProviderReducer = slice.reducer;
